import React, { Component } from "react";
import { Panel } from "react-bootstrap";
import "../Elements/FromGroup/form_select.css"
import AscModal from "../Elements/Modal/Modal";
import { EditAutoCallListManagement } from "../Elements/AscElements/AutoCallListElements";

/**
 * 自動発信リスト項目名管理画面
 */
export default class AutoCallListManagementModal extends Component {
    render() {
        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                onClick={this.props.onClick}
                >
                <Panel bsStyle="info">
                    <Panel.Heading>
                        <Panel.Title>
                            <div className="text-danger modal-checked-message">
                                {this.props.state.blankFlag
                                    ? this.props.langText.Message.Blankerr
                                    : false}
                            </div>
                            <div className="text-danger modal-checked-message">
                                {this.props.state.duplicateFlag
                                    ? this.props.langText.Message.DuplicateItemName + '(' + this.props.state.duplicateItem + ')'
                                    : false}
                            </div>
                        </Panel.Title>
                    </Panel.Heading>

                    <Panel.Body>
                        <EditAutoCallListManagement
                            state={this.props.state}
                            langText={this.props.langText}
                            charaLimit={this.props.charaLimit}
                            validationHandle={this.props.validationHandle}
                            onTextChange_Limit={this.props.onTextChange_Limit}
                            onMultiValueFormTextChange={this.props.onMultiValueFormTextChange}
                            onMultiValueFormSizeChange={this.props.onMultiValueFormSizeChange}
                        />
                    </Panel.Body>
                </Panel>
            </AscModal>
        );
    }
}
